<template>
  <div class="solution-adult">
    <div class="banner-container">
      <div class="banner-img"></div>
      <div class="banner-content">
        <div class="banner-title">未成年人内容安全审核解决方案</div>
        <div class="banner-info">用AI的力量净化网络环境，守护青少年健康成长</div>
      </div>
      <div class="banner-bg"></div>
    </div>
    <div class="items-details">
      <div class="solution-title">未成年人内容安全审核解决方案</div>
      <div class="solution-content-intro">
        <div class="content">
          未成年人内容安全审核解决方案运用腾讯优图人脸人体、图像识别、OCR等视觉AI领域的前沿技术，结合网信办“清朗”行动细则、未成年人保护法以及网络安全法等与未成年人网络安全相关的法律法规，形成未成年人保护和青少年模式两大解决方案。通过与相关企业的合作，助力企业建立完善长效的涉青少年网络内容治理机制，遏制网上违法和不良信息的传播，为青少年营造清朗的网络环境。
        </div>
        <div class="intro-image"></div>
      </div>
    </div>
    <div class="items-details adult">
      <div class="adult-protect">
        <div class="info">
          <div class="info-title">未成年人保护</div>
          <div class="info-content">
            提供未成年人保护内容审核解决方案，对以未成年人为主体的内容进行拦截，切断未成年人相关信息非法传播的途径，做未成年人的保护罩
          </div>
        </div>
        <div class="adult-item adult-sex">
          <div class="adult-content">
            <div class="adult-content-info">
              • 性侵害<br>
              • 未成年人大尺度照片<br>
              • 未成年人性感低俗
            </div>
          </div>
          <div class="title">未成年人色情低俗</div>
        </div>
        <div class="adult-item adult-secret">
          <div class="adult-content">
            <div class="adult-content-info">
              • 未成年人直播<br>
              • 未成年人个人信息
            </div>
          </div>
          <div class="title">未成年人隐私</div>
        </div>
        <div class="adult-item adult-porn">
          <div class="adult-content">
            <div class="adult-content-info">
              • 校园暴力欺凌<br>
              • 虐待未成年人
            </div>
          </div>
          <div class="title">未成年人暴力欺凌</div>
        </div>
      </div>
      <div class="adult-modle">
        <div class="adult-item adult-acg">
          <div class="adult-content">
            <div class="adult-content-info">
              • 儿童邪典片<br>
              • ACG腐文化<br>
              • ACG色情/暴恐
            </div>
          </div>
          <div class="title">不良ACG</div>
        </div>
        <div class="adult-item adult-behavior">
          <div class="adult-content">
            <div class="adult-content-info">
              • 吸毒/抽烟/饮酒<br>
              • 诱导未成年自残/自杀/犯罪<br>
              • 高危行为动作
            </div>
          </div>
          <div class="title">不良行为</div>
        </div>
        <div class="adult-item adult-info">
          <div class="adult-content">
            <div class="adult-content-info">
              • 色情/暴恐<br>
              • 封建迷信、传教<br>
              • 不良广告
            </div>
          </div>
          <div class="title">不良信息</div>
        </div>
        <div class="info">
          <div class="info-title">青少年模式</div>
          <div class="info-content">
            提供青少年模式内容审核解决方案，对未成年人不宜接收的内容进行过滤，切断不良信息向未成年人传播的途径，做未成年人的滤芯
          </div>
        </div>
      </div>
    </div>
    <div class="items-details statistics">
      <div class="statistics-container">
        <div class="statistics-number-container">
          <div class="statistics-number">
            <span class="big-num">8</span>
            <span class="unit">个</span>
          </div>
          <div class="number-item">服务全球国家</div>
        </div>
        <div class="statistics-number-container">
          <div class="statistics-number">
            <span class="big-num">100</span>
            <span class="unit">+家</span>
          </div>
          <div class="number-item">上线企业</div>
        </div>
        <div class="statistics-number-container">
          <div class="statistics-number">
            <span class="big-num">1000</span>
            <span class="unit">+亿</span>
          </div>
          <div class="number-item">审核图片总量</div>
        </div>
        <div class="statistics-number-container">
          <div class="statistics-number">
            <span class="big-num">51263</span>
            <span class="unit">万</span>
          </div>
          <div class="number-item">累计拦截不良内容</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SolutionBanner from '../common/SolutionBanner';
import bannerConstant from './data/BannerConstant';

export default {
  name: '',
  components: {
    SolutionBanner
  },
  data() {
    return {
      bannerConstant,
      AnchorsItems: ['方案介绍', '方案流程', '方案优势', '应用场景']
    };
  },
  methods: {
    downloadExcel(url, newPage) {
      if (newPage) {
        window.open(url, '_blank');
        return;
      }
      window.open(url, '_self');
    }
  }
};
</script>

<style lang="less" scoped>
.solution-adult {
  font-size: 14px;
  color: #333333;
  div {
    box-sizing: border-box;
  }
  .banner-container{
    margin-top: 63px;
    width: 100%;
    height: 650px;
    position: relative;
    color: #ffffff;
    .banner-img{
      position: absolute;
      width: 100%;
      height: 640px;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 100% 640px;
      background-image: url(./img/adult/banner.svg);
    }
    .banner-bg{
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 130px;
      background-repeat: no-repeat;
      background-position: center bottom;
      background-size: cover;
      background-image: url(./img/adult/shape.svg);
    }
    .banner-content{
      position: relative;
      padding-top: 120px;
      width: 1200px;
      margin: 0 auto;
      .banner-title{
        line-height: 50px;
        font-size: 44px;
        color: #FFFFFF;
      }
      .banner-info{
        padding-top: 20px;
        font-size: 18px;
        color: #FFFFFF;
        letter-spacing: 4px;
        line-height: 28px;
      }
    }
  }
  .items-details{
    padding-bottom: 70px;
    overflow: hidden;
    &.adult {
      height: 1200px;
      background-color: rgba(205,239,230,0.40);
      .title {
        position: relative;
        padding-top: 30px;
        padding-bottom: 12px;
        font-size: 20px;
        color: #292D33;
        letter-spacing: 2px;
        text-align: center;
        background-image: url(./img/adult/element1.svg);
        background-repeat: no-repeat;
        background-position: center bottom;
      }
      .content {
        font-size: 17px;
        color: #205A5A;
        line-height: 26px;
      }
      .info {
        display: inline-block;
        width: 300px;
        margin-right: 56px;
        .info-title {
          font-size: 30px;
          color: #205A5A;
        }
        .info-content {
          padding-top: 30px;
          font-size: 16px;
          color: #205A5A;
          line-height: 30px;
        }
      }
      .adult-item {
        position: relative;
        vertical-align: top;
        display: inline-block;
        width: 250px;
        height: 310px;
        background-color: #FFFFFF;
        box-shadow: 0 20px 36px 0 rgba(0,152,153,0.30);
        border-radius: 25px;
        margin-right: 26px;
        .adult-content-info{
          display: none;
        }
        &:hover {
          .adult-content {
            height: 100%;
            width: 100%;
            position: absolute;
            background-image: url(./img/adult/shape_hover.svg);
            background-position: center;
            background-repeat: no-repeat;
            .adult-content-info {
              display: block;
              padding-top: 114px;
              padding-left: 36px;
              font-size: 16px;
              color: #205A5A;
              line-height: 30px;
            }
          }
          .title {
            background-image: none;
            color: #205A5A;
            letter-spacing: 2px;
          }
        }
      }
      .adult-protect {
        margin: 0 auto 0;
        width: 1200px;
        vertical-align: top;
        padding-top: 190px;
        .adult-sex {
          background-image: url(./img/adult/A1.svg);
          background-position: bottom;
          background-repeat: no-repeat;
        }
        .adult-secret {
          background-image: url(./img/adult/A2.svg);
          background-position: bottom;
          background-repeat: no-repeat;
        }
        .adult-porn {
          background-image: url(./img/adult/A3.svg);
          background-position: bottom;
          background-repeat: no-repeat;
        }
      }
      .adult-modle {
        margin: 0 auto 0;
        width: 1200px;
        vertical-align: top;
        padding-top: 200px;
        .info {
          margin-left: 56px;
          margin-right: 0;
        }
        .adult-acg {
          background-image: url(./img/adult/B1.svg);
          background-position: bottom;
          background-repeat: no-repeat;
        }
        .adult-behavior {
          background-image: url(./img/adult/B2.svg);
          background-position: bottom;
          background-repeat: no-repeat;
        }
        .adult-info {
          background-image: url(./img/adult/B3.svg);
          background-position: bottom;
          background-repeat: no-repeat;
        }
      }
    }
    &.statistics {
      height: 300px;
      padding-bottom: 0;
      background-image: url(./img/adult/bg.png);
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      .statistics-container {
        width: 1200px;
        margin: 0 auto;
        .statistics-number-container {
          margin-top: 100px;
          vertical-align: top;
          display: inline-block;
          text-align: center;
          color: #60FFDB;
          width: 295px;
          .statistics-number {
            .big-num {
              font-size: 60px;
            }
            .unit {
              padding-left: 12px;
              font-size: 24px;
            }
          }
          .number-item {
            padding-top: 15px;
            font-size: 18px;
          }
        }
      }
    }
    .solution-title{
      margin-top: 70px;
      margin-bottom: 40px;
      font-size: 30px;
      color: #333;
      text-align: center;
      line-height: 1.0;
    }
    .solution-content-intro{
      width: 1170px;
      margin: 0 auto;
      .content{
        font-size: 16px;
        color: #212121;
        line-height: 1.8;
        text-align: justify;
        margin-bottom: 40px;
      }
      .intro-image {
        width: 600px;
        height: 500px;
        margin: 0 auto;
        background: url(./img/adult/func_intro.svg);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/solution/panels/SolutionAdult.vue